import { camelCase } from 'lodash'

/**
 * take in experiment name and tranform into
 * camel case key for local storage
 */
export const experimentNameToKey = (experimentName: string) =>
  `${camelCase(experimentName)}Experiment`
